// plugins/auth.js
import {useAuthStore} from "~/stores/auth/index.js";

export default defineNuxtPlugin(async () => {
    // const { $pinia } = useNuxtApp()

    // Attendre que les stores soient chargés
    // await nextTick()
    const authStore = useAuthStore()

    // Vérifier d'abord si on a le cookie
    try {
        await authStore.checkAuth()
        // console.log('check auth:',authStore)
    } catch (error) {
        // console.log('Auth initialization failed:', error, $pinia)
        // Le cookie existe mais n'est pas valide, on le nettoie
        await authStore.logout()
        navigateTo('/auth/login')
    }


})